import React, {useEffect, useState} from 'react';
import {ProForm, ProFormSelect} from "@ant-design/pro-components";
import {Alert, Modal} from "antd";
import User from "../../../models/User";
import {AvailableOrder} from "../models/AvailableOrder";
import {Carrier} from "../../../models/Carrier";

interface AssignDriverModalSchema {
    open: boolean;
    submit: (documentDriver: string | null, vehicle: string | null) => void;
    setOpen: (value: boolean) => void;
    drivers: User[];
    orderIds: React.Key[];
    orders: AvailableOrder[];
    carriers: Carrier[];
}

const AssignDriverModal = ({open, submit, setOpen, orderIds, drivers, orders, carriers}: AssignDriverModalSchema): JSX.Element => {
    const [storeString, setStoreString] = useState('');
    const [ordersSelectedString, setOrdersSelectedString] = useState('');


    const getDriverOptions = () => {
        return drivers.filter((driver) => {
            if(driver.carriers.length > 0) {
                let carrierCheck = carriers.filter((carrier) => {
                    return driver.carriers.includes(carrier.id);
                }).find((carrier) => {
                    return carrier.name.toUpperCase() === storeString.toUpperCase();
                });

                return carrierCheck;
            }
            return true;
        }).map((driver) => {
            return {
                value: driver.id,
                label: `${driver.name} ${driver.lastname} [Placa: ${driver.plateNumber}]`
            };
        });
    }

    useEffect(() => {
        const selectedOrders = orders.filter((order) => {
            return orderIds.includes(order.seqId);
        });

        setStoreString((selectedOrders.length > 0 ? selectedOrders[0].store : ''));
        setOrdersSelectedString(selectedOrders.map((order) => order.orderClient).join(', '));
    }, [orders, orderIds]);


    return (
        <Modal
            title="Asignar driver"
            open={open}
            destroyOnClose
            onCancel={() => { setOpen(false) }}
            closable
            keyboard
            footer={null}
        >
            <hr style={{ border: '0', borderTop: '1px solid #c3c3c3'}}/>

            <Alert
                description={<>La lista de drivers solo muestra a los que tengan asignado a la tienda: <b>{storeString}</b> y a los que aún no presentan ninguna tienda asignada.</>}
                type="info"
                showIcon
            />

            <ProForm<any>
                style={{ marginTop: '20px' }}
                onFinish={async (values: any) => {
                    const driverId = values.driver;
                    const driverSelected = drivers.find((driver) => {
                        return driver.id === driverId;
                    });

                    if(driverSelected) {
                        const documentDriver = driverSelected.documentNumber;
                        const vehicle = driverSelected.plateNumber;
                        await submit(documentDriver, vehicle);
                    }

                }}
                submitter={{
                    searchConfig: {
                        submitText: 'Asignar'
                    },
                    resetButtonProps: {
                        style: {
                            display: 'none',
                        },
                    },
                    submitButtonProps: {
                        style: {
                            marginLeft: '-8px',
                            marginTop: '10px'
                        }
                    },
                }}
            >
                <ProForm.Group>
                    <ProFormSelect
                        options={getDriverOptions()}
                        width="xl"
                        name="driver"
                        label="Driver"
                        rules={[{ required: true, message: 'Debe de seleccionar el Driver' }]}
                    />

                    <span><b>{ orderIds.length === 1 ? 'Órden seleccionada' : 'Órdenes seleccionadas' }:</b> <em>{ordersSelectedString}</em></span>
                </ProForm.Group>
            </ProForm>
        </Modal>
    );
};

export default AssignDriverModal;